// extracted by mini-css-extract-plugin
export default {"workOrderSummaryTable":"WorkOrderSummaryTable_workOrderSummaryTable__UCdxd"};